import {
  GetServerSidePropsContext,
  InferGetServerSidePropsType,
  NextPage,
} from 'next';
import { GetServerSideProps } from 'next/types';
import React from 'react';
import BlankLayout from 'src/@core/layouts/BlankLayout';
import CarketaValuation from 'src/@carketa/sales-packet/CarketaValuation';
import RouterIsReady from 'src/@carketa/app/RouterIsReady';

const CarketaValuationPage: NextPage<
  InferGetServerSidePropsType<typeof getServerSideProps>
> = ({ vin }) => {
  return (
    <BlankLayout>
      <RouterIsReady>
        <CarketaValuation vin={vin} />
      </RouterIsReady>
    </BlankLayout>
  );
};

export default CarketaValuationPage;

export const getServerSideProps: GetServerSideProps = async (
  ctx: GetServerSidePropsContext
) => {
  return {
    props: {
      vin: ctx.query.vin,
    },
  };
};
